var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { Waypoint } from "react-waypoint";
import { GlobalContext } from "../Context";
import { dispatchEvent } from "../../utils/analytics";
export var MainWrapper = function (_a) {
    var children = _a.children, theme = _a.theme;
    var useStyles = createUseStyles(function (theme) {
        var _a;
        return {
            main: (_a = {
                    width: "100%",
                    position: "relative",
                    textAlign: "center",
                    fontSize: theme.typography.body.fontSize,
                    lineHeight: theme.typography.body.lineHeight,
                    "& *": {
                        boxSizing: "border-box",
                    }
                },
                _a[theme.mediaQuery(512)] = {
                    fontSize: theme.typography.body.fontSizeMobile,
                },
                _a[theme.mediaQuery(1440)] = {
                    fontSize: theme.typography.body.fontSizeTablet,
                },
                _a[theme.mediaQuery(2000)] = {
                    fontSize: theme.typography.body.fontSize,
                },
                _a),
        };
    });
    var article = useContext(GlobalContext).article;
    var handlePageRead = function () {
        // analyticArticleEnd(articleTitle, articleId);
        dispatchEvent("Scrolled_to_End", __assign({}, article));
    };
    var classes = useStyles({ theme: theme });
    return (React.createElement("div", { className: classes.main },
        children,
        React.createElement(Waypoint, { onEnter: handlePageRead })));
};
